export default __webpack_public_path__ + "static/media/model-3.4caec68b.jpg";